module.exports = __webpack_public_path__ + "img/predix-casting-emptystate.181f46f0.png";